import { render, staticRenderFns } from "./PolicyPaymentCreate.vue?vue&type=template&id=5b3ce65f&"
import script from "./PolicyPaymentCreate.vue?vue&type=script&lang=js&"
export * from "./PolicyPaymentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports